/* eslint-disable no-underscore-dangle */
import { ProposalEntity, ProposalStatus } from '@modules/clients/entities/client/api/dto/clientProposal.dto';
import {
  ProposalCreationBankProductsRoute, ProposalCreationClientAndMortgageRoute, ProposalCreationConfiguratorRoute
} from '@modules/proposals/presentation/routes';

const OFFER_AMOUNT_LIMIT = 5;

export const PROPOSAL_CREATION_RULES = {
  getCreateProposalLatestRoute: (proposal: ProposalEntity) => {
    if (proposal.status === ProposalStatus.GENERATED) {
      return ProposalCreationConfiguratorRoute.to;
    }
    if (proposal.bank_offers && proposal.bank_offers?.length > 0) {
      return ProposalCreationBankProductsRoute.to;
    }

    return ProposalCreationClientAndMortgageRoute.to;
  },
  OFFER_AMOUNT_LIMIT,
};
